module.exports = __webpack_public_path__ + "static/media/cosentino-message.6af62afd.svg";